import { z } from 'zod';

const UserView = z.object({
  deleted: z.boolean().optional(),
  id: z.number(),
  /** Filter definition as JSON string */
  mandatory_filters: z.string(),
  name: z.string().optional(),
  schema_version: z.number().optional(),
});
export type UserView = z.infer<typeof UserView>;

const Permission = z.object({
  additional_info: z.nullable(z.unknown()),
  deleted: z.boolean(),
  description: z.string(),
  display_name: z.string(),
  group_type: z.object({
    display_name: z.string(),
    id: z.number(),
    name: z.string(),
  }),
  id: z.number(),
  name: z.string(),
});
export type Permission = z.infer<typeof Permission>;

export const User = z.object({
  active: z.boolean(),
  active_user_view: z.nullable(UserView),
  disclaimer_version: z.nullable(z.number()),
  email: z.string(),
  exclude_from_token_validation: z.nullable(z.boolean()),
  first_name: z.nullable(z.string()),
  groups: z.array(Permission),
  id: z.number(),
  idp: z.nullable(z.string()),
  internal: z.boolean(),
  last_name: z.nullable(z.string()),
  provider_user_id: z.nullable(z.string()),
  roles: z.array(Permission),
  scopes: z.array(z.string()),
  self_url: z.nullable(z.string()),
  user_name: z.nullable(z.string()),
  user_views: z.nullable(z.array(z.number())),
});
export type User = z.infer<typeof User>;

export const LoginResponse = z.object({
  expiration: z.number(),
  id: z.number(),
  needsPasswordChange: z.boolean(),
  refresh_token: z.string(),
  tenant: z.string(),
  tenant_name_or_api_id: z.string(),
  token: z.string(),
  user: User,
});
export type LoginResponse = z.infer<typeof LoginResponse>;

export const LoginModeResponse = z.object({
  changePasswordUrl: z.nullable(z.string()).optional(),
  mode: z.union([z.literal('local'), z.literal('multi'), z.literal('sso')]),
  resetPasswordUrl: z.nullable(z.string()).optional(),
});

export type LoginModeResponse = z.infer<typeof LoginModeResponse>;
